import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags'; 
import { Link } from 'react-router-dom'; // Added Meta Tag npm Package
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, UncontrolledTooltip, Badge, Alert } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import { AREAS, COMPANY, USERS, UPLOADSMSFILE, SENDSMS, DELETESMS } from 'helpers/url_helper';
import { Config, TOAST_OPTIONS,  downloadBase64File, getContentTypeFromBase64 } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import { Button} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'
import {
    PaginationListStandalone,
    PaginationProvider,
  } from "react-bootstrap-table2-paginator";

    const SMSReminders = () => {

        toastr.options = TOAST_OPTIONS;

        const [modal_users, setmodal_users] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [usersList, setUsersList] = useState([]);
        const [areas, setAreas] = useState([])
       
        const [isloading, setIsloading] = useState(false)

        const [id, setId] = useState('')
        const [name, setName] = useState('')
        const [title, setTitle] = useState('')
        const [phone, setPhone] = useState('+252')
        const [email, setEmail] = useState('')
        const [category, setCategory] = useState('')
        const [selectedAreas, setSelectedAreas] = useState([])
        const [userStatus, setUserStatus] = useState('')
        const [dateRegistered, setDateRegistered] = useState('')
        const [lastLogin, setLastLogin] = useState('')
        const [changePass, setChangePass] = useState('')

        const [modal_attachmentsM, setmodal_attachmentsM] = useState(false);
        const [modal_list, setmodal_list] = useState(false)
        const [loadingFiles, setLoadingFiles] = useState(false)
        const [selectedFileM, setSelectedFileM] = useState([])
        const [uploadedFilesM, setUploadedFilesM] = useState([])

        const [lid, setLid] = useState('')
        const [dateTime, setDateTime] = useState('')
        const [status, setStatus] = useState('')
        const [listName, setListName] = useState('')
        const [smsList, setSmsList] = useState([])

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_users = () => {
          setmodal_users(!modal_users);
          removeBodyCss();
        }
        const tog_attachmentsM = () => {
            setmodal_attachmentsM(!modal_attachmentsM);
            removeBodyCss();
        }
        const tog_list = () => {
            setmodal_list(!modal_list);
            removeBodyCss();
        }
        const handleSaveFilesM = () =>{
            selectedFileM.forEach((f)=>{
                const reader = new FileReader();
                reader.readAsDataURL(f);
                reader.onloadend = () => {
                    const base64Data = reader.result;
                    const fileName = f.name;
                    const fileExtension = fileName.split('.').pop();
                    const fileData = {
                        DateTime:(new Date()),
                        FileName:fileName,
                        FileExtension: fileExtension,
                        fileContentType:getContentTypeFromBase64(base64Data),
                        FileContentsBase64:base64Data.split(',')[1]
                    }
                    if(getContentTypeFromBase64(base64Data) != 'text/csv'){
                      toastr.error("Upload only csv files")
                    }else{
                      setIsloading(true)
                      axios.post(UPLOADSMSFILE, JSON.stringify(fileData), Config).then((r)=>{
                          if(r.data.status == 1){
                              toastr.info(r.data.message)
                              tog_attachmentsM()
                              fetchData()
                          }else{
                              toastr.info(r.data.message)
                          }
                          setIsloading(false)
                      }).catch((e)=>{ 
                          console.log(e)
                          setIsloading(false)
                      })
                    }
                }
            })
        }
        const fetchData = () => {
          setIsloading(true)
          const Configx = {
            auth: {
              username: 'xk9',
              password: 'xkcd89',
            },
            headers: {
              'Content-Type': 'application/json',
            },
          }
          axios.get(UPLOADSMSFILE, Configx).then((r)=>{ 
            setUsersList(r.data);
            setIsloading(false) 
          }).catch((e)=>{  
            setIsloading(false) 
            console.error(e);
          });
        }
        const handleSendSMS = () =>{
            tog_list();
            const data = {lid : lid}
            toastr.info('Sending messages in background...')
            axios.post(SENDSMS, JSON.stringify(data), Config).then((r)=>{
                toastr.info(r.data.message)
                fetchData()
                setIsloading(false)
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const handleDelete = () =>{
            setIsloading(true)
            const data = {lid : lid}
            axios.post(DELETESMS, JSON.stringify(data), Config).then((r)=>{
              tog_list();
              toastr.info(r.data.message)
              fetchData()
              setIsloading(false)
          }).catch((e)=>{
              console.log(e)
              setIsloading(false)
          })
        }
        useEffect(() => {
            fetchData();
        },[]);


    
     
        
        const handleClickEdit = (row) => {
            tog_list()
            setLid(row.id)
            setIsEdit(true)
            setDateTime(row.dateTime)
            setStatus(row.status.trim())
            setName(row.name)
            setSmsList(row.lines)
        }
        const clearData = () =>{
          setIsEdit(false); 
        }
        const handleClickAdd = () => {  
          setIsEdit(false);
          clearData() 
          tog_users();  
        }
        const pageOptions = {
            sizePerPage: 25,
            totalSize: usersList.length, // replace later with size(orders),
            custom: true,
          }
          var node = useRef();

        const { SearchBar } = Search;
        const columns = [

        {
          dataField: 'dateTime',
          text: 'Date and time',
          sort: true
        },
        {
          dataField: 'name',
          text: 'List name',
          sort: true
        },
        {
            dataField: 'lines',
            text: 'Numbers',
            sort: true,
            formatter: nosFormatter,
            align:'center',
            headerStyle: { textAlign: 'center' } 
          },
          {
            dataField: 'status',
            text: '',
            sort: true,
            formatter: statusFormatter
          },
        {
          dataField: "",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'dateTime',
          order: 'desc'
        }];
        function statusFormatter(cellContent, row) {
          if (row.status == "Sent out") {
            return (
              <div>
                  <Badge className="me-2 bg-success">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-danger">
                  { cellContent }
                  </Badge>
              </div>
            );
          }
        }
        function actionFormatter(cellContent, row){
          return(
            <>
            <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  onClick={() => { handleClickEdit(row); }}
                >
                  Details
            </Button>
          </>
          )
        }
        function nosFormatter(cellContent, row){
            return(
                <b>
              {row.lines.length}
                </b>
            )
          }

        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>SMS Reminders | {COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title={COMPANY} breadcrumbItem="Reminders" />


                        <Row>


                            <Col lg="12">
                            <Card>
                                <CardBody>
                                <CardTitle className="mb-4">&nbsp;</CardTitle>

                                
                                <Modal isOpen={modal_attachmentsM} toggle={() => { tog_attachmentsM()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Billing file` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_attachmentsM(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row >
                                    <Col xl={12}>
                                    <div className="mb-3">
                                            <label htmlFor="floatingnameInput">Attach Files</label>
                                            <input type="file" multiple className="form-control"  onChange={(e)=>setSelectedFileM(Array.from(e.target.files))}   />
                                        </div>
                                    </Col>
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isloading?<Alert>Please wait...</Alert>:(<>
                                    <button onClick={() => {  tog_attachmentsM() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveFilesM}>Create list...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_list} toggle={() => { tog_list()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `SMS List` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_list(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row >
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Name</label>
                                            <input type="text" className="form-control" value={name} onChange={(e)=>setName(e.target.value)} disabled={true}  />
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Date and time</label>
                                            <input type="text" className="form-control" value={dateTime} onChange={(e)=>setDateTime(e.target.value)} disabled={true}  />
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Status</label>
                                            <input type="text" className="form-control" value={status} onChange={(e)=>setStatus(e.target.value)} disabled={true}  />
                                        </div>
                                    </Col>
                                    {smsList.map((s,k)=>(
                                        <Col xl={12} key={k}>
                                        <div className="mb-3">
                                            <label>{k+1}. {s.phone}</label>
                                            <textarea className="form-control" rows={4}  defaultValue={s.msg}  />
                                        </div>
                                    </Col>
                                    ))}
                                  </Row>
                                  </div>
                                  {(status != 'Sent out') ? (
                                  <div className="modal-footer">
                                    {isloading?<Alert>Please wait...</Alert>:(<>
                                    <button onClick={() => {  tog_list() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-warning" onClick={handleDelete}>Delete SMS...</button>
                                    <button className="btn btn-success" onClick={handleSendSMS}>Send SMS...</button>
                                    </>)}
                                  </div>
                                  ) : null}
                                </Modal>

                                {usersList && (usersList.length > 0) && (
                                    <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField="id"
                                    columns={columns}
                                    data={usersList}
                                    >
                                    {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                      keyField="id"
                                      data={ usersList }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                           

                                                <Row className='mb-5'>
                                                  <Col lg={8} className='mb-2'>
                                                    <div  className="rounded bg-light d-grid gap-2">
                                                      <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                    </div>
                                                  </Col>
                                            
                                                  <Col lg={4}> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn"
                                                        onClick={() => { tog_attachmentsM() }}
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Upload file
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                            <Row>
                                              <Col xl="12">
                                                
                                            
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={ usersList } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table-sm align-middle table-check" }
                                                    {...toolkitProps.baseProps}
                                                  //onTableChange={handleTableChange}
                                                    {...paginationTableProps}
                                                  ref={node}
                                                  />
                                            
                                            </Col>
                                            </Row>
                                            <Row className="align-items-md-center mt-30">
                                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                                <PaginationListStandalone
                                                  {...paginationProps}
                                                />
                                              </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                    </ToolkitProvider>
                                    )}
                                    </PaginationProvider>
                                
                                )}
                                {usersList && (usersList.length < 1) && (
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                        </div>
                                        <div>
                                        <h5>No lists Found</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>

                                )}
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default SMSReminders;